import React from 'react';
const VtxThemeContext = React.createContext({ theme: 'light' });
const VtxThemeProvider = VtxThemeContext.Provider;
export default VtxThemeProvider;
export { VtxThemeContext };
